import { JourneysLegacyRoute } from './-components';
import { createFileRoute } from '@tanstack/react-router';
import { Navigate } from '@/utils/navigate';
import { LegacySignupRedirect } from './-signup-route-gate';

function UsersRoute() {
  const { _splat } = Route.useParams();
  const firstSegment = (_splat ?? '').split('/')[0];
  // Legacy `/users/login` (Unity) → canonical Hydra `/login`. Everything else
  // under /users stays with the embedded app.
  if (firstSegment === 'login') {
    // Preserve any query params (e.g. `?origin`, `?token`) the legacy link carried.
    const search = Object.fromEntries(new URLSearchParams(window.location.search));
    return <Navigate to="/login" replace={true} search={search} />;
  }
  // Legacy signup aliases follow the signup rollout flag: flag on → /signup in
  // the shell; flag off → the embedded app performs its own redirect.
  if (firstSegment === 'register' || firstSegment === 'signup') {
    return <LegacySignupRedirect />;
  }
  return <JourneysLegacyRoute />;
}

export const Route = createFileRoute('/users/$')({
  component: UsersRoute,
});
